import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicRankingTwoWayHorizontalBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'number', required: true },
    { field: 'x2', type: 'number', required: true },
    { field: 'y', type: 'string', required: true },
    { field: 'group', type: 'date', required: true }
  ],
  businessRules: [
    {
      name: 'dynamic-ranking-two-way-sufficient-data',
      validator: data => data.length > 1,
      message: 'Dynamic ranking two-way chart requires more than 1 data point',
      suggestion: 'Provide multiple data points for meaningful ranking visualization',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-two-way-x-diversity',
      validator: (data, layer) => {
        const { encoding } = layer;
        const xValues = new Set(data.map(item => item[encoding?.x as string]));
        return xValues.size > 1;
      },
      message: 'Dynamic ranking two-way chart requires diverse x-field values',
      suggestion: 'Provide different numerical values in the x field for comparison',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-two-way-x2-diversity',
      validator: (data, layer) => {
        const { encoding } = layer;
        const x2Values = new Set(data.map(item => item[encoding?.x2 as string]));
        return x2Values.size > 1;
      },
      message: 'Dynamic ranking two-way chart requires diverse x2-field values',
      suggestion: 'Provide different numerical values in the x2 field for comparison',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-two-way-y-diversity',
      validator: (data, layer) => {
        const { encoding } = layer;
        const yValues = new Set(data.map(item => item[encoding?.y as string]));
        return yValues.size > 1;
      },
      message: 'Dynamic ranking two-way chart requires diverse y-field categories',
      suggestion: 'Provide different categories in the y field for ranking',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-two-way-time-series',
      validator: (data, layer) => {
        const { encoding } = layer;
        const groupValues = new Set(data.map(item => item[encoding?.group as string]));
        return groupValues.size > 1;
      },
      message: 'Dynamic ranking chart requires multiple time points for animation',
      suggestion: 'Provide at least 2 different time points in the group field',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-two-way-meaningful-difference',
      validator: (data, layer) => {
        const { encoding } = layer;
        return data.some(item => {
          const xVal = Number(item[encoding?.x as string]);
          const x2Val = Number(item[encoding?.x2 as string]);
          return Math.abs(xVal - x2Val) > 0;
        });
      },
      message: 'Two-way ranking chart works best with meaningful differences between x and x2',
      suggestion: 'Ensure x and x2 fields have different values to show comparison effectively',
      severity: 'warning'
    }
  ]
};
